import { Component, signal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LogixOrbComponent } from '../../shared/assistant/logix-orb.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, LogixOrbComponent],
  template: `
    <div class="min-h-screen w-full flex items-center justify-center bg-canvas px-4 font-sans">
      <div class="w-full max-w-sm bg-surface rounded-2xl shadow-xl border border-slate-200 p-8">

        <div class="flex flex-col items-center mb-7">
          <app-logix-orb [size]="56" [active]="true"></app-logix-orb>
          <h1 class="mt-3 text-xl font-bold text-slate-800 tracking-tight">Logix AI ERP</h1>
          <p class="text-sm text-slate-500">Sign in to continue</p>
        </div>

        <form (ngSubmit)="submit()">
          <label class="block text-sm font-medium text-slate-700 mb-1">Username</label>
          <input type="text" name="userName" autocomplete="username"
                 [ngModel]="userName()" (ngModelChange)="userName.set($event)"
                 class="w-full mb-4 px-3 py-2 rounded-lg border border-slate-300 text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500"
                 placeholder="e.g. admin.rashid" />

          <label class="block text-sm font-medium text-slate-700 mb-1">Password</label>
          <input type="password" name="password" autocomplete="current-password"
                 [ngModel]="password()" (ngModelChange)="password.set($event)"
                 class="w-full mb-4 px-3 py-2 rounded-lg border border-slate-300 text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500"
                 placeholder="••••••••" />

          @if (error()) {
            <div class="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{{ error() }}</div>
          }

          <button type="submit" [disabled]="loading()"
                  class="w-full py-2.5 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors">
            {{ loading() ? 'Signing in…' : 'Sign in' }}
          </button>
        </form>

        <p class="mt-5 text-center text-[11px] text-slate-400">Logix AI ERP · Secure sign-in</p>
      </div>
    </div>
  `
})
export class LoginComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  userName = signal('');
  password = signal('');
  error = signal('');
  loading = signal(false);

  submit(): void {
    this.error.set('');
    if (!this.userName().trim() || !this.password()) {
      this.error.set('Please enter your username and password.');
      return;
    }
    this.loading.set(true);
    this.auth.login(this.userName().trim(), this.password()).subscribe({
      next: res => {
        this.loading.set(false);
        if (res?._obj?.token) this.router.navigateByUrl('/');
        else this.error.set(res?._message || 'Login failed.');
      },
      error: err => {
        this.loading.set(false);
        this.error.set(err?.error?._message || 'Invalid username or password.');
      }
    });
  }
}
